// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UieVwJ {
  height: 100%;
}

.qmABlW {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  padding: 24px;
  font-family: var(--font-family-base);
  font-size: var(--type-label-md-font-size);
  color: var(--status-error-dark);
  text-align: center;
  background: var(--surface-neutral-white);
  border-radius: var(--radius-s);
  box-shadow: var(--shadow-s);
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/HiringPage/HiringPage.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,oCAAoC;EACpC,yCAAyC;EACzC,+BAA+B;EAC/B,kBAAkB;EAClB,wCAAwC;EACxC,8BAA8B;EAC9B,2BAA2B;AAC7B","sourcesContent":[".hiringPageContainer {\n  height: 100%;\n}\n\n.errorMessage {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 200px;\n  padding: 24px;\n  font-family: var(--font-family-base);\n  font-size: var(--type-label-md-font-size);\n  color: var(--status-error-dark);\n  text-align: center;\n  background: var(--surface-neutral-white);\n  border-radius: var(--radius-s);\n  box-shadow: var(--shadow-s);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hiringPageContainer": `UieVwJ`,
	"errorMessage": `qmABlW`
};
module.exports = ___CSS_LOADER_EXPORT___;
